import { render, staticRenderFns } from "./allnews.vue?vue&type=template&id=0298613c&scoped=true"
import script from "./allnews.vue?vue&type=script&lang=js"
export * from "./allnews.vue?vue&type=script&lang=js"
import style0 from "./allnews.vue?vue&type=style&index=0&id=0298613c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298613c",
  null
  
)

export default component.exports